import { render, staticRenderFns } from "./phopoPopUp.vue?vue&type=template&id=07d907bb&scoped=true"
import script from "./phopoPopUp.vue?vue&type=script&lang=js"
export * from "./phopoPopUp.vue?vue&type=script&lang=js"
import style0 from "./phopoPopUp.vue?vue&type=style&index=0&id=07d907bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d907bb",
  null
  
)

export default component.exports